import { BADGE_TYPES } from './consts';

// TODO: Think if the papers field is required, could be annoying to update
export const ETAL = {
  displayName: 'Et Al',
  photoURL: 'https://minimal-assets-api.vercel.app/assets/images/avatars/avatar_3.jpg',
  affiliation: 'Oak University',
  role: 'PhD Student',
  bio: 'I am a PhD student at Pear Academy. Did my Msc under the supervision of Professor Oak. My interests are Image Registration and GANs',
  reviews: [
    { paper: '52345.1234', reviewer_name: 3, bounty: 66 },
    { paper: '8214.11114v4', reviewer_name: 4, bounty: 66 },
    { paper: '88121.0142', reviewer_name: 2, bounty: 66 },
    { paper: '10234.5678', reviewer_name: 2, bounty: 66 },
    { paper: '04242.1818v4', reviewer_name: 2, bounty: 66 },
  ],
  reviewerBadges: [
    { type: BADGE_TYPES.FIRST_REVIEW, times: 1 },
    { type: BADGE_TYPES.EARLY_BIRD, times: 6 },
    { type: BADGE_TYPES.MONTH_STRIKE, times: 2 },
  ],
};

export const Willard = {
  displayName: 'FDC Willard',
  photoURL: 'https://minimal-assets-api.vercel.app/assets/images/avatars/avatar_4.jpg',
  affiliation: 'PearAI',
  role: 'Researcher',
  bio: 'I am a researcher at PearAI, focusing on making the world a better place. ',
  reviews: [],
  reviewerBadges: [],
};

export const adam = {
  displayName: 'Adam',
  photoURL: 'https://minimal-assets-api.vercel.app/assets/images/avatars/avatar_5.jpg',
  affiliation: 'Ranger University',
  role: 'MSc Student',
  bio: 'I am a student at Ranger University. My main focus in deep neural network optimization.',
  reviews: [{ paper: '52345.1234', reviewer_name: 1, bounty: 66 }],
  reviewerBadges: [
    { type: BADGE_TYPES.FIRST_REVIEW, times: 1 },
    { type: BADGE_TYPES.MONTH_STRIKE, times: 2 },
  ],
};

export const AnoNymus = {
  displayName: 'Ano Nymus',
  photoURL: 'https://minimal-assets-api.vercel.app/assets/images/avatars/avatar_1.jpg',
  affiliation: 'Oak University',
  role: 'Full Professor',
  bio: 'I am a professor at Oak University. My research includes a broad range of Computer Vision and Machine Learning problems. Accepting new students.',
  papers: ['2008.00951'],
  reviews: [{ paper: '2008.00951', reviewer_name: 1, bounty: 54 }],
  reviewerBadges: [
    { type: BADGE_TYPES.FIRST_REVIEW, times: 1 },
    { type: BADGE_TYPES.EMERGENCY_REVIEWER, times: 2 },
  ],
  fields: [],
  //  TODO: Mock badges
};

export const users = [ETAL, AnoNymus, Willard, adam];
